/** Rate pairs shown in the table (screenshot order) and sent on create. */
export const currencyExchangeRateFields = [
    { key: 'rate_eur_cny', label: 'eurToCny' },
    { key: 'rate_eur_usd', label: 'eurToUsd' },
    { key: 'rate_eur_gbp', label: 'eurToGbp' },
    { key: 'rate_eur_brl', label: 'eurToBrl' },
    { key: 'rate_eur_hkd', label: 'eurToHkd' },
    { key: 'rate_eur_myr', label: 'eurToMyr' },
    { key: 'rate_gbp_brl', label: 'gbpToBrl' },
    { key: 'rate_cny_usd', label: 'cnyToUsd' },
    { key: 'rate_cny_brl', label: 'cnyToBrl' },
    { key: 'rate_cny_myr', label: 'cnyToMyr' },
    { key: 'rate_cny_hkd', label: 'cnyToHkd' },
    { key: 'rate_usd_brl', label: 'usdToBrl' },
    { key: 'rate_usd_gbp', label: 'usdToGbp' },
    { key: 'rate_usd_hkd', label: 'usdToHkd' },
    { key: 'rate_usd_myr', label: 'usdToMyr' },
    { key: 'rate_hkd_brl', label: 'hkdToBrl' },
    { key: 'rate_hkd_myr', label: 'hkdToMyr' },
    { key: 'rate_myr_brl', label: 'myrToBrl' },
] as const;

export type CurrencyExchangeRateKey = (typeof currencyExchangeRateFields)[number]['key'];
